import { useContext } from 'react';

import { TTitleContext } from '@models/Title';

import TitleContext from './context';

const useTitleContext = (): TTitleContext => useContext(TitleContext);

export default useTitleContext;
